export const ESHOP_TEST_ID = {
    PROGRESS_BAR: 'eshop-progress-bar',
    PROGRESS_BAR_SKELETON: 'eshop-progress-bar-skeleton',
    PRODUCT_CARD_SKELETON: 'product_card_skeleton',
    PRODUCTS_CARDS_SKELETON: 'products_cards_skeleton',
    B2B_PRODUCT_PAGE: 'b2b_product_page',
    B2C_PRODUCT_PAGE: 'b2c_product_page',
    INTERACTION_PANEL: 'product-interaction-panel',
    ESHOP_PRODUCT_PAGE_TITLE: 'eshop-product-page-title',
    PRICE_WITHOUT_MONTHLY_PAYMENT: 'price_without_monthly_payment',
    PRICE_WITH_MONTHLY_PAYMENT: 'price_with_monthly_payment',
    PRICE_WITH_RESIDUAL_AMOUNT: 'price_with_residual_amount',
    PRODUCT_OFFER_PRICE_PRIMARY_LINE: 'product_offer_price_primary_line',
    PRODUCT_OFFER_PRICE_SECONDARY_LINE: 'product_offer_price_secondary_line',
    ESHOP_PRODUCT_SUMMARY: 'eshop-product-summary',
    DESCRIPTION_CHECKLIST: 'description_checklist',
    ENERGY_EFFICIENCY_CLASS: 'energy-efficiency-class',
    ENERGY_EFFICIENCY_DOCUMENT: 'energy-efficiency-document',
    ESHOP_PRODUCT_PAGE_DESCRIPTION_SECTION: 'eshop-product-page-description-section',
    UPSELL_PAGE: 'upsell_page',
    UPSELL_PAGE_SKELETON: 'upsell_page_skeleton',
    DESKTOP_STICKY_SUMMARY: 'b2c_desktop_sticky_summary',
    STICKY_SUMMARY_PRODUCT_NAME: 'sticky-summary-product-name',
    B2C_CONTRACT_TYPE_SELECTOR: 'b2c_contract_type_selector',
    GIFT_LIST_LOADER: 'gift-list-loader',
    GIFT_LIST_SECTION: 'gift-list-section',
    GIFT_ITEM_PRICE_BLOCK: 'gift-item-price-block',
    GIFT_ITEM_OLD_PRICE_BLOCK: 'gift-item-old-price-block',
    GIFT_LOCAL_CODE: 'gift-local-code',
    GIFT_SLIDER_CHECKBOX: 'gift-slider-checkbox',
    GIFT_SLIDER_RADIO: 'gift-slider-radio',
    GIFT_ITEM_CHECKBOX: 'gift-item-checkbox',
    GIFT_ITEM_RADIO: 'gift-item-radio',
    GIFT_LEGAL_TEXT: 'gift-legal-text',
    GIFT_DETAILS_MODAL: 'gift-modal',
    GIFT_PRICE_BLOCK: 'gift-price-block',
    PRODUCT_COMPARE_LINK: 'product_compare_link',
    ESIM_NOTICE: 'esim_notice',
    ORDER_VAS_BLOCK: 'order_vas_block',
    ORDER_VAS_BLOCK_B2B: 'order_vas_block_b2b',
    RATE_PLAN_VAS_BLOCK: 'rate_plan_vas_block',
    RENT_PLAN_VAS_BLOCK: 'rent_plan_vas_block',
    VAS_MODAL: 'vas_modal',
    INCREMENT_INPUT: 'increment_input',
    INCREMENT_INPUT_INCREMENT_BTN: 'increment_input_increment_btn',
    INCREMENT_INPUT_DECREMENT_BTN: 'increment_input_decrement_btn',
    RENTING_PLAN_SELECTOR_FORM: 'renting_plan_selector_form',
    RENTING_PLAN_OLD_PRICE: 'renting_plan_old_price',
    RENTING_PLAN_LOADER: 'renting-plan-loader',
    PRODUCT_STOCK_STATUS: 'product_stock_status',
    PRODUCT_PREORDER_STOCK_STATUS: 'product_preorder_stock_status',
    CART_BOX_RENTING_CARD: 'cart_box_renting_card',
    CART_BOX_RENTING_CARD_RESIDUAL_PRICE: 'cart_box_renting_card_residual_price',
    CHECKOUT_DELIVERY: 'checkout_delivery',
    PAGE_LOADER_SPINNER: 'eshop_page_loader',
    PRODUCT_INSURANCE_BLOCK: 'product_insurance_block',
    PRODUCT_INSURANCE_BADGE: 'product_insurance_badge',
    PRODUCT_INSURANCE_CHECKBOX: 'product_insurance_checkbox_purpur',
    LOCAL_CODES: 'local-codes',
    CART_BOX: 'cart_box',
    CART_BOX_PRODUCT_CARD: 'cart_box_product_card',
    CART_BOX_PRODUCT_CARD_TITLE: 'cart_box_product_card_title',
    CART_BOX_PRODUCT_CARD_PRICE: 'cart_box_product_card_price',
    CART_BOX_PRODUCT_CARD_PRODUCT_PRICE: 'cart_box_product_card_product_price',
    CART_BOX_PRODUCT_CARD_INITIAL_PAYMENT: 'cart_box_product_card_initial_payment',
    CART_BOX_UPSELL_CARD: 'cart_box_upsell_card',
    CART_BOX_GIFT_CARD: 'cart_box_gift_card',
    CART_BOX_RATE_PLAN_CARD: 'cart_box_rate_plan_card',
    CART_BOX_RATE_PLAN_CARD_TITLE: 'cart_box_rate_plan_card_title',
    CART_BOX_RATE_PLAN_CARD_PRICE: 'cart_box_rate_plan_card_price',
    CART_BOX_INSURANCE_CARD: 'cart_box_insurance_card',
    CART_BOX_INSURANCE_CARD_TITLE: 'cart_box_insurance_card_title',
    CART_BOX_INSURANCE_CARD_PRICE: 'cart_box_insurance_card_price',
    CART_BOX_TOTAL_PRICE_BLOCK: 'cart_box_total_price_block',
    CART_BOX_TOTAL_IMMEDIATE_PAYMENT: 'cart_box_total_immediate_payment',
    CART_BOX_TOTAL_MONTHLY_PAYMENT: 'cart_box_total_monthly_payment',
    CART_BOX_ACTION_BUTTON: 'cart-box-action-button',
    CART_BOX_LEGAL_TEXT: 'cart-box-legal-text',
    REVERSE_VAT_LABEL: 'reverse_vat_label',
    INSURANCE_VAS: 'insurance_vas',
    ADDITIONAL_INFO_BOX: 'additional_info_box',
    PRODUCT_VARIANT_SELECTOR: 'product_variant_selector',
    CHECKOUT_PAYMENT_PAGE: 'checkout_payment_page',
    BANK_SELECTION: 'bank-selection',
    CHECKOUT_ORDER_ERROR: 'checkout_order_error',
    PROGRESS_WIZARD: 'progress_wizard',
    PRICE_BLOCK_TAX_DIFFERENCE: 'price_block_tax_difference',
    FULL_PRICE_FORM: 'full_price_form',
    EXTEND_PLAN_FORM: 'extend_plan_form',
    TRANSFER_PLAN_FORM: 'transfer_plan_form',
    NEW_PLAN_FORM: 'new_plan_form',
    RESTRICTION_INFO: 'restriction-info',
    DISCOUNT_FORM: 'discount-form',
    COUPON_MESSAGE: 'coupon-message',
    PRODUCT_DETAILS_SKELETON: 'product_details_skeleton',
    CLIENT_DATA_FORM_DOWNLOAD_CONTRACT: 'client-data-form-download-contract-summary-btn',
    MOBILE_SUMMARY_EXPAND_BUTTON: 'mobile-summary-expand-button',
    CART_SUMMARY: 'cart-summary',
    CART_PROLONGATION_WARNING: 'cart-prolongation-warning',
    CART_EXPIRED_WARNING: 'cart-expired-warning',
    CART_EXTEND_PLAN_MODAL: 'cart-extend-plan-modal',
    PRODUCT_REFERENCE_LIST: 'product-reference-list',
    PRODUCT_REFERENCE_LIST_LOAD_MORE_BTN: 'product-list-load-more-btn',
    UPSELL_PRODUCT_CARD_OLD_PRICE: 'upsell-product-card-old-price',
    ESIM_NOTIFICATION: 'esim-notification',
    FREE_DELIVERY_BADGE: 'free-delivery-badge',
    CHECKOUT_PAYMENT_PRICE: 'checkout-payment-price',
    CHECKOUT_PAYMENT_PRICE_MONTHLY: 'checkout-payment-price-monthly',
    CART_SUMMARY_TOTAL_PRICE: 'cart-summary-total-price',
    CART_SUMMARY_MONTHLY_PRICE: 'cart-summary-monthly-price',
    PRODUCT_DETAILS_MODAL: 'product-details-modal',
    DISCOUNT_APPLIED_SUCCESSFULLY: 'discount-applied-successfully',
    CLIENT_DATA_FORM: 'client-data-form',
    CLIENT_DATA_B2B_FORM: 'client-data-b2b-form',
    TECHNICAL_CHARACTERISTICS: 'technical-characteristics',
    BADGES_COLUMN: 'badges-column',
    MARKETING_TAG: 'marketing-tag',
    SAP_RATE_PLAN_SELECTOR: 'sap-rate-plan-selector',
    LEGACY_RATE_PLAN_SELECTOR: 'legacy-rate-plan-selector',
    RATE_PLAN_SELECTOR: 'rate-plan-selector',
    RATE_PLAN_DETAILS: 'rate-plan-details',
    RATE_PLAN_LOADER: 'rate-plan-loader',
    RATE_PLAN_VAS_MODAL: 'rate-plan-vas-modal',
    OPEN_RATE_PLAN_VAS_MODAL: 'open-rate-plan-vas-modal',
    LEASING_PLAN_SELECTOR: 'leasing-plan-selector',
    LEASING_PLAN_LOADER: 'leasing-plan-loader',
    LEASING_PERIOD_SELECTOR: 'leasing-period-selector',
    LEASING_RADIO_SELECTOR: 'leasing-radio-selector',
    PREDEFINED_INITIAL_PAYMENT_SELECTOR: 'predefined-initial-payment-selector',
    PAYMENT_TYPE_SELECTOR: 'payment-type-selector',
    INITIAL_PAYMENT_CALCULATOR: 'initial-payment-calculator',
    SHOW_MORE_OR_LESS: 'show-more-or-less',
    ADD_TO_CART: 'add-to-cart',
    CHECKOUT_PAYMENT_METHOD: 'checkout-payment-method',
    CHECKOUT_PAYMENT_SUBMIT: 'checkout-payment-submit',
    ORDER_CONFIRMATION_LOADER: 'order-confirmation-loader',
    EXTENDED_WARRANTY_SELECTOR: 'extended-warranty-selector',
    EXTENDED_WARRANTY_CHECKBOX: 'extended-warranty-checkbox',
    OPEN_GIFT_DETAILS_MODAL: 'open-gift-details-modal',
    MODAL_GO_BACK_BTN: 'close-gift-details-modal-and-go-back',
    MODAL_CLOSE_BTN: 'modal-close-btn',
    NETFLIX_CARD: 'netflix-card',
    DISNEY_CARD: 'disney-card',
    CART_BOX_NETFLIX_CARD: 'cart-box-netflix-card',
    CART_BOX_NETFLIX_CARD_TITLE: 'cart-box-netflix-card-title',
    CART_BOX_NETFLIX_CARD_PRICE: 'cart-box-netflix-card-price',
    CART_BOX_NETFLIX_CARD_CHANGE_BUTTON: 'cart-box-netflix-card-change-button',
    CART_BOX_DISNEY_CARD: 'cart-box-disney-card',
    CART_BOX_DISNEY_CARD_TITLE: 'cart-box-disney-card-title',
    CART_BOX_DISNEY_CARD_PRICE: 'cart-box-disney-card-price',
    CART_BOX_DISNEY_CARD_CHANGE_BUTTON: 'cart-box-disney-card-change-button',
    UPSELL_GO_BACK_LINK: 'upsell-go-back-link',
};
